var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMythic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3966 52.1028C29.7006 53.0154 30.9918 53.0146 31.2946 52.1015L34.7736 41.6088L45.2457 46.6879C46.0994 47.102 46.9959 46.2055 46.5818 45.3518L41.5927 35.065L52.1155 31.4024C53.0105 31.0909 53.0105 29.8251 52.1155 29.5136L41.6064 25.8557L46.588 15.5548C47.0006 14.7017 46.1056 13.8066 45.2524 14.2192L35.2379 19.0622L31.2731 7.67128C30.9616 6.77624 29.6958 6.77624 29.3843 7.67127L25.4081 19.0946L15.1714 13.9587C14.3105 13.5268 13.3967 14.4419 13.8297 15.3021L19.0792 25.7309L7.68402 29.5259C6.77135 29.8299 6.77221 31.1211 7.68529 31.4239L19.0703 35.1987L13.8433 45.6457C13.4129 46.506 14.3266 47.4185 15.1863 46.9869L25.9015 41.6079L29.3966 52.1028Z",
    fill: "url(#paint0_linear_2944_4805)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3924 21.0437C21.5286 20.6133 20.6115 21.5252 21.0461 22.3825L25.1148 30.4095L21.0495 38.4784C20.6176 39.3356 21.5345 40.2449 22.3972 39.8149L30.4425 35.8041L38.479 39.6749C39.3357 40.0876 40.2353 39.1942 39.8198 38.3435L35.9565 30.4333L39.8263 22.4867C40.2404 21.6365 39.3422 20.7446 38.4861 21.1558L30.4059 25.0363L22.3924 21.0437Z",
    fill: "url(#paint1_linear_2944_4805)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2944_4805",
    x1: 2.50684,
    y1: 7.2168,
    x2: 56.316,
    y2: 52.8623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2944_4805",
    x1: 20.9346,
    y1: 20.9336,
    x2: 41.3482,
    y2: 38.2541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2ABFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMythic);
export default __webpack_public_path__ + "static/media/mythic.b13b51b3530f7a6e34cd69cf2744ba49.svg";
export { ForwardRef as ReactComponent };